import { useContext, useEffect, useState } from 'react';
import { OFL_FEATURE } from '../constants';
import FeatureManagerContext from '../contexts/FeatureManagerContext';
import { isProduction } from '../helpers/isProduction';
import { getBooleanFromString } from '../helpers/string/getBooleanFromString';
import AsyncStorage from '@react-native-async-storage/async-storage';

const useOFLExperiment = (): { isOFL: boolean; isLoading: boolean } => {
    const [value, setValue] = useState<boolean>();
    const [isLoading, setIsLoading] = useState(true);
    const featureManager = useContext(FeatureManagerContext);
    const isReactNative = typeof document === 'undefined';

    const getValueFromUrl = (): boolean | null => {
        if (isReactNative) {
            return null;
        }

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('ofl')) {
            return getBooleanFromString(urlParams.get('ofl'));
        }

        return null;
    };

    useEffect(() => {
        if (!isLoading) {
            return;
        }

        const valueFromUrl = getValueFromUrl();

        if (valueFromUrl !== null) {
            setValue(valueFromUrl);
            setIsLoading(false);
            return;
        }

        AsyncStorage.getItem(OFL_FEATURE).then((valueFromStorage) => {
            if (valueFromStorage && !isProduction()) {
                setValue(getBooleanFromString(valueFromStorage));
                setIsLoading(false);
                return;
            }

            if (featureManager) {
                const featureManagerValue = featureManager.getBooleanValue(OFL_FEATURE) || false;

                setValue(featureManagerValue);
                setIsLoading(false);
            }
        });
    }, [featureManager, isLoading]);

    return {
        isOFL: !isReactNative && value === true, // Temporary disable OFL for mobile app
        isLoading: !isReactNative && (isLoading || value === undefined)
    };
};

export default useOFLExperiment;
